import React from 'react';
import moment from 'moment';
import { Grid, Typography } from '@material-ui/core';

export default function ClientStatus({ data }) {
  const { observation, createdAt } = data;

  return(
    <Grid container>
      <Grid xs={12}>
        <Typography color='primary'>
          {observation} em <b>{moment(createdAt, 'DD/MM/YYYY HH:mm:ss').format('LLL')}</b>
        </Typography>
      </Grid>
    </Grid>
  );
}